<template>
    <el-dropdown v-if="params.node.data.entityType !== 'type'" trigger="click">
      <span class="el-dropdown-link">
        <el-button size="mini" icon="el-icon-more"></el-button>
      </span>
      <el-dropdown-menu slot="dropdown">
        <div v-if="!(params.node.data.entityType === 'account' && !params.node.data.active)">
          <el-dropdown-item v-if="disabledAccountsTypeId.some(val => val === params.node.data.accountTypeId) && params.node.data.entityType === 'account'"  @click.native="invokeParentMethod('create-tax-account')" icon="el-icon-circle-plus-outline">Add Tax Account</el-dropdown-item>
          <el-dropdown-item v-else @click.native="invokeParentMethod('add')" icon="el-icon-circle-plus-outline">{{$t('general_add')}}</el-dropdown-item>
<!--          <el-dropdown-item v-if="params.node.data.entityType === 'account' && !params.node.data.taxId" :disabled="params.node.data.taxId" @click.native="invokeParentMethod('assign-tax')" icon="el-icon-circle-plus-outline">{{$t('settings_assignTax')}}</el-dropdown-item>-->
          <el-dropdown-item v-if="params.node.data.entityType !== 'folder'" :disabled="params.node.data.entityType === 'type'" @click.native="invokeParentMethod('update')" icon="el-icon-edit-outline">{{$t('general_edit')}}</el-dropdown-item>
          <el-dropdown-item :disabled="params.node.data.entityType === 'type' || params.node.data.entityType === 'class'" @click.native="invokeParentMethod('delete')" icon="el-icon-delete">{{$t('general_remove')}}</el-dropdown-item>
        </div>
        <el-dropdown-item v-if="params.node.data.entityType === 'account'" @click.native="invokeParentMethod('updateActiveAccount')" icon="el-icon-edit-outline">{{params.node.data.active ? 'Deactivate' : 'Activate' }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
</template>

<script>

export default {
name: "actionCellRenderer",
  data() {
    return {
      // tax accounts
      disabledAccountsTypeId: [8,11,12,13]
    }
  },
  methods: {
    invokeParentMethod(action) {
      this.params.context.componentParent.methodFromActionCell(action, this.params)
    }
  }
}
</script>

<style scoped>

</style>
